import { render, staticRenderFns } from "./BuyIndex.vue?vue&type=template&id=1f9395ff&scoped=true&"
import script from "./BuyIndex.vue?vue&type=script&lang=js&"
export * from "./BuyIndex.vue?vue&type=script&lang=js&"
import style0 from "./BuyIndex.vue?vue&type=style&index=0&id=1f9395ff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9395ff",
  null
  
)

export default component.exports